import { createAction } from 'redux-act';

export const updateFetchBookingAuthProcess = createAction('authentication/AUTH_IS_READY');
export const updateAuthMethod = createAction('authentication/AUTH_METHOD_UPDATE');
export const retrieveBookingAuthMethod = createAction('authentication/RETRIEVE_BOOKING_AUTH_METHOD');
export const setAuthToSSO = createAction('authentication/SET_AUTH_TO_SSO');
export const setIsSSOLoginScreenVisible = createAction<boolean>('authentication/SET_IS_SSO_LOGIN_SCREEN_VISIBLE');
export const setAuthToOAuth = createAction('authentication/SET_AUTH_TO_OAUTH');
